import { Header } from '../Header';
import { DrawTable, isMobileScreen } from '@apply/ui';
import { applicationInsights } from '../ApplicationInsights';
import { useAuthentication } from '../LoginPage';
import { FeatureType } from '@apply/constants';
import { ReactElement, useMemo } from 'react';
import { HomePageLink } from '../HomePageLink';

function DrawSummary(): ReactElement {
    const { isFeatureEnabled, authentication } = useAuthentication();
    const borrowerName = useMemo(() => `${authentication?.user?.firstName} ${authentication?.user?.lastName}`, [authentication]);

    const isDrawsEnabled: boolean = useMemo(() => isFeatureEnabled(FeatureType.Draws), [isFeatureEnabled]);
    const isInspectionsEnabled: boolean = useMemo(() => isFeatureEnabled(FeatureType.Inspections), [isFeatureEnabled]);

    if (!isDrawsEnabled) {
        return (
            <>
                <Header />
                <HomePageLink />
                <h1 style={{ margin: 20, color: 'black' }}>Feature is currently turned off.</h1>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className='flex'>
                <div
                    className='main-content bfi-draw'
                    style={{ padding: 0, backgroundColor: '#f4f4f4' }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: 10,
                            paddingRight: isMobileScreen() ? 0 : 20,
                        }}
                    >
                        <div>
                            <div style={{ marginBottom: 10, paddingLeft: 20 }}>
                                <HomePageLink />
                            </div>
                            <DrawTable
                                applicationInsights={applicationInsights}
                                borrowerName={borrowerName}
                                isInspectionsEnabled={isInspectionsEnabled}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DrawSummary;
